"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _sortable = require("@dnd-kit/sortable");

var _utilities = require("@dnd-kit/utilities");

var _RowdragndropGreyOutline = _interopRequireDefault(require("@druva-apps/orion-icons/lib/RowdragndropGreyOutline"));

var SortableGroup = function SortableGroup(_ref) {
  var id = _ref.id,
      children = _ref.children,
      data = _ref.data;

  var _useSortable = (0, _sortable.useSortable)({
    id: id
  }),
      listeners = _useSortable.listeners,
      setNodeRef = _useSortable.setNodeRef,
      transform = _useSortable.transform,
      transition = _useSortable.transition,
      attributes = _useSortable.attributes;

  var style = {
    transform: _utilities.CSS.Translate.toString(transform),
    transition: transition
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-column-group",
    ref: setNodeRef,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-heading"
  }, /*#__PURE__*/_react["default"].createElement(_RowdragndropGreyOutline["default"], (0, _extends2["default"])({
    className: "oui-mr-2 oui-drag-handle",
    muted: false
  }, listeners, attributes)), data.title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "oui-group-body"
  }, children));
};

SortableGroup.propTypes = {
  id: _propTypes["default"].string,
  data: _propTypes["default"].object,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = SortableGroup;
exports["default"] = _default;